import React from 'react'
import Grid from '@material-ui/core/Grid'
import Podcast from '../Card/Podcast'
import Blog from '../Card/Blog'
import Review from '../Card/Review'
import { Post as IPost } from '../../../types/post'

interface Props {
  posts: IPost[]
  type: 'blog' | 'podcast' | 'review'
}

function PostGrid({ posts, type }: Props): JSX.Element {
  return (
    <Grid container justify="flex-start" spacing={1}>
      {posts.map((post) => (
        <Grid item key={post._id} xs={12} sm={4} md={3}>
          {type === 'podcast' && <Podcast post={post} />}
          {type === 'blog' && <Blog post={post} />}
          {type === 'review' && <Review post={post} />}
        </Grid>
      ))}
    </Grid>
  )
}

export default PostGrid
